import React from "react";

const partnerLogos = [
  require("../../assets/home/beacons.png"),
  require("../../assets/home/beacons.png"),
  require("../../assets/home/beacons.png"),
  require("../../assets/home/beacons.png"),
  require("../../assets/home/beacons.png"),
  require("../../assets/home/beacons.png"),
  require("../../assets/home/beacons.png"),
  require("../../assets/home/beacons.png"),
  require("../../assets/home/beacons.png"),
  require("../../assets/home/beacons.png"),
  require("../../assets/home/beacons.png"),
];

const PartnersGrid = ({ isMobile }) => {
  if (isMobile) {
    return (
      <div
        style={{ marginTop: "30px", textAlign: "center", padding: "0 16px" }}
      >
        <h2
          style={{ fontSize: "20px", fontWeight: "800", marginBottom: "16px" }}
        >
          Our Partners
        </h2>

        <div style={{ padding: "0 16px 30px" }}>
          <LogoGrid logos={partnerLogos.slice(0, 6)} isMobile={isMobile} />
          <LogoGrid logos={partnerLogos.slice(6)} isMobile={isMobile} />
        </div>
      </div>
    );
  }

  return null; // Hide partners grid on desktop as per original code
};

const LogoGrid = ({ logos, isMobile }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: "12px",
      marginBottom: "16px",
    }}
  >
    {logos.map((logo, idx) => (
      <div
        key={idx}
        className="partner-logo"
        style={{
          height: "70px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "8px",
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          transition: "all 0.3s ease",
        }}
      >
        <img
          src={logo}
          alt={`partner-${idx}`}
          style={{
            maxWidth: "80%",
            maxHeight: "80%",
            objectFit: "contain",
            transition: "all 0.3s ease",
          }}
        />
      </div>
    ))}
  </div>
);

export default PartnersGrid;
